var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-text",class:_vm.contentClass},[_c('div',{staticClass:"dashboard-text-inner",style:(_vm.contentStyle)},[_vm._v(" "+_vm._s(_vm.model['content'])+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }